<template>
  <div>
    <form @submit.prevent="onSubmit">
      <transition :name="$_transition" mode="out-in" appear>
        <QPage padding>
          <h2 class="step-title-optional">
            {{ $filters.whitespacedPunctuation($t("ETAB.PAGES.SIGNUP.STEPS.MAIN.EMPLOYEES.@TITLE")) }}
          </h2>
          <div class="text-center">
            <ExtraRoundedBtn
              v-for="nb in FORM_EMPLOYEES_NUMBER_INPUT_VALUES"
              :key="nb.id"
              :label="$t(nb.label)"
              :active="isEmployeeNumberSelected(nb)"
              @click="onSelect(nb)"
            />
          </div>
        </QPage>
      </transition>
    </form>
  </div>
</template>

<script>
  import { signupMixin } from "@etab/mixins";
  import { ACTION_SIGNUP_UPDATE } from "@etab/stores/types";
  import { FORM_EMPLOYEES_NUMBER_INPUT_VALUES, FIREBASE_EVENTS } from "@core/constants";
  import { useSignupStore } from "@etab/stores/signup";
  import { TrackingManager } from "@core/managers/tracking.manager";
  import { mapStores } from "pinia";
  export default {
    mixins: [signupMixin],
    data() {
      return {
        selectedNumber: null,
      };
    },
    computed: {
      ...mapStores(useSignupStore),
      isBtnDisabled() {
        // i want  to know if the selected number is null
        return this.selectedNumber === null;
      },
    },
    created() {
      this.selectedNumber = this.$_signupModel[this.$ISignup.employeesNumber];
      this.isAlreadySelected();
      this.FORM_EMPLOYEES_NUMBER_INPUT_VALUES = FORM_EMPLOYEES_NUMBER_INPUT_VALUES;
    },
    methods: {
      onSelect(nb) {
        this.selectedNumber = nb;
        if (this.selectedNumber) {
          this.signupStore[ACTION_SIGNUP_UPDATE]({ [this.$ISignup.employeesNumber]: this.selectedNumber.value });
          TrackingManager.addEvent({
            event: FIREBASE_EVENTS.FUNNEL,
            step: "step7_2_nb_employee--optional",
          });
          this.$_nextStep();
        }
      },
      isAlreadySelected() {
        const alreadySelectedNumber = this.FORM_EMPLOYEES_NUMBER_INPUT_VALUES?.find(
          (nb) => nb.label === this.$_signupModel[this.$ISignup.employeesNumber],
        );
        if (alreadySelectedNumber) {
          this.selectedNumber = alreadySelectedNumber;
        }
      },
      isEmployeeNumberSelected(employeesNumber) {
        return this.selectedNumber?.id === employeesNumber.id;
      },
    },
  };
</script>
